import React from 'react'
import styled from 'styled-components'

import colors from 'styles/colors'
import text from 'styles/text'
import media from 'styles/media'

import { useMedia } from 'utils/hooks'
import links from 'utils/links'

import HeadingAnimation from 'components/HeadingAnimation'
import AppleButton from 'components/buttons/Apple'
import GoogleButton from 'components/buttons/GooglePlay'

import PhonePNG from 'assets/images/communityPhoneV2.png'

const Community: React.FC = () => {

  const buttonLong = useMedia(false, false, false, true)
  const topPerc = useMedia(54, 54, 37, 39)
  const botPerc = useMedia(51, 51, 22, 20)

  return (
    <Wrapper >
      <Title>
        <HeadingAnimation
          text="Join The Community"
          topPerc={topPerc}
          botPerc={botPerc}
        />
      </Title>
      <Content>
        <GradientText>Download the app</GradientText>
        <ButtonRow>
          <AppleButton long={buttonLong}/>
          <GoogleButton long={buttonLong}/>
        </ButtonRow>
        <LinkContainer>
          <HR/>
          <Link href={links.discord} target="_blank">Join our Discord</Link>
          <HR/>
          <Link href={links.home} target="_blank">FAQs</Link>
        </LinkContainer>
      </Content>
        <Phone src={PhonePNG} alt="iPhone" loading="lazy"/>
    </Wrapper>
  )
}

export default Community

const Wrapper = styled.section`
  width: 100%;
  position: relative;

  height: 63.06vw;

  ${media.tablet} {
    height: 96.634vw;
  }

  ${media.mobile} {
    height: 342.667vw;
  }
`

const Title = styled.h6`
  ${text.desktop.h3}
  letter-spacing: -0.05em;
  position: absolute;
  z-index: 3;
  text-transform: uppercase;
  pointer-events: none;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;

  top: 7.29vw;
  width: 96vw;

  ${media.tablet} {
    ${text.tablet.h3}
    text-align: left;
    transform: translateX(0%);

    top: 11.33vw;
    width: 73.24vw;
    left: 5.86vw;
  }

  ${media.mobile} {
    ${text.mobile.h1}
    letter-spacing: -0.09em;
    width: 109.067vw;
    left: 50vw;
    top: 21.333vw;
  }
`

const Content = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;

  left: 13.4vw;
  top: 19.65vw;

  ${media.tablet} {
    left: 5.86vw;
    top: 35.74vw;
  }

  ${media.mobile} {
    height: 340vw;
    left: 4vw;
    top: 60vw;
  }
`

const Text = styled.p`
  ${text.desktop.bodyL}  

  ${media.tablet} {
    ${text.tablet.bodyL}
  }
`

const GradientText = styled(Text)`
  background: ${colors.horzGradient};
  ${text.style.gradient}

  margin-bottom: 2.78vw;

  ${media.tablet} {
    margin-bottom: 3.91vw;
  }

  ${media.mobile} {
    ${text.mobile.bodyL}
    position: relative;
    top: 135vw;
    margin-left: 13.067vw;
    margin-bottom: 10.667vw;
  }
`

const ButtonRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  width: 29.44vw;
  margin-bottom: 6.94vw;

  ${media.tablet} {
    width: 41.41vw;
    margin-bottom: 9.77vw;
  }

  ${media.mobile} {
    position: relative;
    top: 135vw;
    flex-direction: column;
    width: 92vw;
    gap: 5.333vw;
  }
`

const LinkContainer = styled.div`
  ${media.mobile} {
    position: relative;
    top: 150vw;
    z-index: 10;
  }
`

const HR = styled.div`  
  background: ${colors.horzGradient};
  height: 1px;

  width: 35.83vw;
  margin-bottom: 1.04vw;

  ${media.tablet} {
    width: 52.05vw;
    margin-bottom: 1.46vw;
  }

  ${media.mobile} {
    width: 92vw;
    margin-top: 4vw;
    margin-bottom: 4vw;
  }
`

const Link = styled.a`
  ${text.desktop.bodyL}
  color: ${colors.pureWhite};
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  cursor: pointer;

  &::after {
    content: "→";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
    transition: 500ms;
  }

  &:hover {
    &::after {
      transform: translate(50%, -50%);
    }
  }
  
  margin-bottom: 1.04vw;

  ${media.tablet} {
    ${text.tablet.bodyL}
    margin-bottom: 1.46vw;
  }

  ${media.mobile} {
    ${text.mobile.bodyL}
  }
`

const Phone = styled.img`
  position: absolute;
  z-index: 4;

  width: 20.83vw;
  height: 41.74vw;
  top: 11.46vw;
  right: 20.14vw;

  ${media.tablet} {
    width: 29.3vw;
    height: 58.69vw;
    top: 23.54vw;
    right: 7.23vw;
  }

  ${media.mobile} {
    z-index: -1;
    width: 80vw;
    height: 160.267vw;
    left: 11.267vw;
    top: 60vw;
  }
`
  